import React,{useEffect} from 'react';
import ComingSoon from './ComingSoon';
import MyAdress from '../AddressComplete/MyAddresss.jsx'
const ProfileAddress = () => {
  useEffect(() => {
      window.scrollTo(0, 0);  // ⬅️ Scroll to top when this page mounts
    }, []);
  return <MyAdress />;;
};

export default ProfileAddress;
